import type { AppSettingsType } from '@econtractor/types';
import { setObjectValueByPath } from 'utils/helpers/objectValueByPath';

export type SetSettingsAction =
    | { type: 'SET'; settings: AppSettingsType }
    | { type: 'SET_FIELD'; field: string; value: unknown };

export const SetSettingsReducerd = (
    state: AppSettingsType | null,
    action: SetSettingsAction,
): AppSettingsType | null => {
    switch (action?.type) {
        // Встановлюємо всю структуру параметрів
        case 'SET':
            return { ...action.settings };

        // Встановлюємо одне значення
        case 'SET_FIELD':
            if (!state) return state;
            return setObjectValueByPath(state, action.field, action.value) as AppSettingsType;

        default:
            return state;
    }
};
